module.exports = __webpack_public_path__ + "img/demo-chat.58388ce9.jpg";